<template>
<div>
    <blocker :state="state"/>
    <sidebar>
        <p-check class="p-default p-curve" v-model="runningShow">running samples {{runningShow?'':'hidden'}}</p-check><br><br>
        <p-check class="p-default p-curve" v-model="readyShow">ready samples {{readyShow?'':'hidden'}}</p-check><br><br>
        <p-check class="p-default p-curve" v-model="preparedShow">prepared samples {{preparedShow?'':'hidden'}}</p-check><br><br>
        <p-check class="p-default p-curve" v-model="completedShow">completed samples {{completedShow?'':'hidden'}}</p-check><br><br>
        <p-check class="p-default p-curve" v-model="errorShow">error samples {{errorShow?'':'hidden'}}</p-check>
        <br><br>
        <button @click="assign" :disabled="sampleList.filter(sample=>toAssign[sample.vialID]).length <= 0">Assign Project/Workflow</button>
    </sidebar>
    <div class="content">
        <div :hidden="!runningShow">
            <h3>Running samples</h3>
            <v-client-table class="running" :data="runningTableData" :columns="runningColumns" :options="runningOptions">
                <div slot="workflowName" slot-scope="props" @click="showWorkflow(props.row.workflowID.replace('workflow.',''), props.row.name, props.row.project)"> {{props.row.workflowName}}
                </div>
                <div slot="pause" slot-scope="props" class="clickable" @click="$api.call('taskControl.hold', {
                    workflowID: props.row.workflowID,
                })">
                    <font-awesome-icon :icon="['fad', 'pause-circle']"/>
                </div>
            </v-client-table>
            <hr>
        </div>
        <div :hidden="!readyShow">
            <h3>Ready samples</h3>
            <v-client-table class="ready" :data="readyTableData" :columns="readyColumns" :options="readyOptions">
                 <div slot="name" slot-scope="props" style="white-space: nowrap;">
                    <router-link to="/missingconsumables">
                        <font-awesome-icon :icon="['fa', 'bell']" color="#ffa007" v-if="missLocks().filter(u=> u.vialID == props.row.vialID).length > 0"/>
                    </router-link> {{props.row.name}}
                </div>
                <div slot="workflowName" slot-scope="props" @click="showWorkflow(props.row.workflowID.replace('workflow.',''), props.row.name, props.row.project)"> {{props.row.workflowName}}
                </div>
                <div slot="resume" v-if="['onhold', 'userwait'].includes(props.row.status)" slot-scope="props" class="clickable" @click="$api.call('taskControl.release', {
                    workflowID: props.row.workflowID,
                })">
                    <font-awesome-icon :icon="['fad', 'play']"/>
                </div>
                <div slot="abort" slot-scope="props" class="clickable" @click="$api.call('taskControl.abort', {
                    workflowID: props.row.workflowID,
                })">
                    <font-awesome-icon :icon="['fad', 'stop']"/>
                </div>
                <div slot="delete" slot-scope="props" class="clickable" @click="$api.call('taskControl.delete', {
                    workflowID: props.row.workflowID,
                })">
                    <font-awesome-icon :icon="['fad', 'trash']"/>
                </div>
            </v-client-table>
            <hr>
        </div>
        <div :hidden="!preparedShow">
            <h3>Prepared samples</h3>
            <v-client-table class="prepared" :data="preparedTableData" :columns="preparedColumns" :options="preparedOptions" :key="changed">
                <div slot="workflowName" slot-scope="props">{{props.row.workflowName}}
                    <p-check class="p-default p-curve" v-model="toAssign[props.row.vialID]" v-if="!props.row.workflowName">Assign</p-check>
                </div>
                <div slot="project" slot-scope="props">{{props.row.project}}
                    <p-check class="p-default p-curve" v-model="toAssign[props.row.vialID]" v-if="!props.row.project">Assign</p-check>
                </div>
            </v-client-table>
            <hr>
        </div>
        <div :hidden="!completedShow">
            <h3>Completed samples</h3>
            <v-client-table class="completed" :data="completedTableData" :columns="completedColumns" :options="completedOptions">
                <div slot="workflowName" slot-scope="props" @click="showWorkflow(props.row.workflowID.replace('workflow.',''), props.row.name, props.row.project)"> {{props.row.workflowName}}
                </div>
                <div slot="log" slot-scope="props" class="clickable">
                    <router-link :to="`samplelogviewer/${props.row.project}/${props.row.name}/${props.row.workflowID.replace('workflow.','')}`">
                        <font-awesome-icon :icon="['far', 'eye']"/>
                    </router-link>
                </div>
            </v-client-table>
            <hr>
        </div>
        <div :hidden="!errorShow">
            <h3>Error samples</h3>
            <v-client-table class="error" :data="errorTableData" :columns="errorColumns" :options="errorOptions">
                <div slot="workflowName" slot-scope="props" @click="showWorkflow(props.row.workflowID.replace('workflow.',''), props.row.name, props.row.project)"> {props.row.workflowName}}
                </div>
                <div slot="log" slot-scope="props" class="clickable">
                    <router-link :to="`samplelogviewer/${props.row.project}/${props.row.name}/${props.row.workflowID.replace('workflow.','')}`">
                        <font-awesome-icon :icon="['far', 'eye']"/>
                    </router-link>
                </div>
            </v-client-table>
            <hr>
        </div>
    </div>
</div>
</template>

<script>
import ProjectWorkflowSelector from './ProjectWorkflowSelector.vue'
import WorkflowViewer from './WorkflowViewer'


export default {
    methods: {
        assign(){
            this.$modal.show(ProjectWorkflowSelector, {
                slots: this.sampleList.filter(sample=>this.toAssign[sample.vialID]),
                close: (project, workflowName)=>{
                    /*let changes = [];
                    Object.keys(this.toAssign).forEach((key)=>{
                        if(this.toAssign[key]){
                            const change = {
                                id: key
                            };
                            if(workflow.length){
                                change.workflow = workflow;
                            }
                            if(project.length){
                                change.project = project;
                            }
                            changes.push(change);
                            this.toAssign[key] = false;
                        }
                    });*/
                    this.$api.call('vials.update', {
                        vials: this.sampleList.filter(sample=>this.toAssign[sample.vialID]),
                    });
                    this.toAssign = [];
                    this.changed = !this.changed;
                }
            }, {
                width: 500,
                height: 500,
                clickToClose: false
            });
        },
        isSample(type){
            return ['ExSample', 'MiniSample', 'SnapVial'].indexOf(type) !== -1;
        },
        missLocks(){
            let misslockVials = [];
            if(this.$store.state.missingConsumables){
                    misslockVials = this.sampleList.filter(sample=> this.$store.state.missingConsumables.overview.find(u=> u.vialID == sample.vialID));
                }
            return misslockVials;
        },
        showWorkflow(vialID, name, project){
            if (project != 'LM1_ND1' && project != 'LM1_ND2') {
                this.$modal.show(WorkflowViewer,{
                    vialID, name, project
                    },{
                    width: 750,
                    height: 480
                })
            }
        }
    },
    components: {
    },
    computed: {
        sampleList(){
            const samples = this.$store.state.vials;
            const sampleList = Object.keys(samples).map(key=>({
                name: samples[key].name,
                project: samples[key].project,
                slot: samples[key].slot,
                workflowName: samples[key].workflowName,
                status: samples[key].status,
                vialType: samples[key].vialType,
                vialID: samples[key].vialID,
                isSample: samples[key].isSample,
                isActiveWorkflow: samples[key].isActiveWorkflow,
                workflowID: samples[key].workflowID,
                confirmation: samples[key].confirmation,
            }));
            console.log(sampleList, 'sampleList')
            return sampleList.filter(sample=>sample.isSample);
        },
        runningTableData(){
            let running = this.sampleList.filter(sample=>sample.isActiveWorkflow && !this.missLocks().find(u=> u.vialID == sample.vialID));
            /*while(running.length < 5){
                running.push({
                    name: '',
                    project: '',
                    slot: '',
                    workflowName: ''
                })
            }*/
            return running;
        },
        readyTableData(){
            
            return this.sampleList.filter(sample=>
                (!sample.isActiveWorkflow || this.missLocks().find(u=> u.vialID == sample.vialID)) &&
                sample.workflowName && 
                sample.project &&
                !(sample.status === 'completed') &&
                !(sample.status === 'error')
            );
        },
        preparedTableData(){
            return this.sampleList.filter(sample=>!sample.workflowName || !sample.project);
        },
        completedTableData(){
            return this.sampleList.filter(sample=>sample.status === 'completed');
        },
        errorTableData(){
            return this.sampleList.filter(sample=>sample.status === 'error');
        }
    },
    created: function(){
        
    },
    props: [
    ],
    data: function(){
        return {
            toAssign: [],
            runningShow: true,
            runningColumns: ['name', 'project', 'slot', 'workflowName', 'vialType', 'pause'],
            runningOptions: {
                sortable: ['name', 'project', 'slot', 'workflowName', 'vialType'],
                sortable: [],
                filterable: [],
                headings: {
                    workflowName: 'Workflow',
                    vialType: 'Type'
                },
                texts:{
                    count:''
                }
            },
            readyShow: true,
            readyColumns: ['name', 'project', 'slot', 'workflowName', 'vialType', 'confirmation', 'resume', 'abort', 'delete'],
            readyOptions: {
                sortable: ['name', 'project', 'slot', 'workflowName', 'vialType'],
                filterable: ['name', 'project', 'workflowName', 'slot'],
                headings: {
                    workflowName: 'Workflow',
                    vialType: 'Type'
                },
            },
            preparedShow: true,
            preparedColumns: ['name', 'project', 'slot', 'workflowName', 'vialType'],
            preparedOptions: {
                sortable: ['name', 'project', 'slot', 'workflowName', 'vialType'],
                filterable: ['name', 'project', 'workflowName', 'slot'],
                    headings: {
                    workflowName: 'Workflow',
                    vialType: 'Type'
                },
            },
            completedShow: true,
            completedColumns: ['name', 'project', 'slot', 'workflowName', 'vialType', 'log'],
            completedOptions: {
                sortable: ['name', 'project', 'slot', 'workflowName', 'vialType'],
                filterable: ['name', 'project', 'workflowName', 'slot'],
                headings: {
                    workflowName: 'Workflow',
                    vialType: 'Type'
                },
            },
            errorShow: true,
            errorColumns: ['name', 'project', 'slot', 'workflowName', 'vialType', 'log'],
            errorOptions: {
                sortable: ['name', 'project', 'slot', 'workflowName', 'vialType'],
                filterable: ['name', 'project','workflowName', 'slot'],
                headings: {
                    workflowName: 'Workflow',
                    vialType: 'Type'
                },
            },
            state: 'loaded',
            changed: false
        }
    }
}

</script>

<style lang="scss">
    @import '../colors.scss';
    .running {
        td, th {
            background-color: rgba(0,255,0,0.1);
        }
    }
    .ready {
        td, th {
            background-color: rgba(255,255,0,0.1);
        }
    }
    .error {
        td, th {
            background-color: rgba(255,0,0,0.1);
        }
    }
    .completed {
        td, th {
            background-color: rgba(0,100,255,0.1);
        }
    }
    .clickable {
        &:hover {
            color: $accromablue;
        }
        text-align: center;
    }
</style>
